import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { LetDirective, PushPipe } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { selectIsDualTheme, selectLanguage } from '@ninety/platform/state';
import { TerraIconModule } from '@ninety/terra';
import {
  StopPropagationDirective,
  NinetyTooltipDirective,
  ButtonComponent,
  ProgressBarComponent,
} from '@ninety/ui/core';

import { GuideActions } from '../../_state/guide.actions';
import { GuideSelectors } from '../../_state/guide.selectors';

@Component({
  selector: 'ninety-getting-started-tracker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [],
  imports: [
    CommonModule,
    PushPipe,
    ProgressBarComponent,
    LetDirective,
    StopPropagationDirective,
    TerraIconModule,
    ButtonComponent,
    NinetyTooltipDirective,
  ],
  styleUrls: ['./getting-started-tracker.component.scss'],
  template: `
    <ng-container *ngrxLet="completionPercentage$ as percentage">
      @if (isExpanded) {
        <div
          ninetyStopPropagation
          class="getting-started-tracker"
          (click)="toggleGettingStartedGuide()"
          [class.dual-theme]="isDualTheme$ | ngrxPush"
          data-product="getting-started-guide-left-nav-element"
          data-cy="getting-started_tracker">
          @if (percentage >= 100) {
            <ninety-button flat icon class="dismiss-guide-btn" ninetyStopPropagation (click)="dismissGuide()">
              <terra-icon icon="x" size="20" />
            </ninety-button>
          }
          <div class="header">
            <div class="title">Getting Started</div>
            Unlock the power of Ninety
          </div>
          <ninety-progress-bar [percentage]="percentage" />
          <div class="completion-percent">
            @if (percentage < 100) {
              <span>{{ percentage | number: '1.0-0' }}% complete</span>
            } @else {
              Unlocked!
            }
          </div>
        </div>
      }
      @if (!isExpanded) {
        <div
          ninetyStopPropagation
          [class.dual-theme]="isDualTheme$ | ngrxPush"
          class="collapsed-tracker"
          (click)="toggleGettingStartedGuide()"
          [ninetyTooltip]="percentage + '% complete'"
          tpPlacement="right"
          data-product="getting-started-guide-left-nav-element"
          data-cy="collapsed-getting-started_tracker">
          <img src="/assets/icons/ninety/90_Logo_Square_Margins_Black.svg" />
          <ninety-progress-bar [percentage]="percentage" />
        </div>
      }
    </ng-container>
  `,
})
export class GettingStartedTrackerComponent implements OnInit {
  private store = inject(Store);

  @Input() isExpanded: boolean;

  protected readonly completionPercentage$ = this.store.select(GuideSelectors.selectCompletionPercentage);
  protected readonly isDualTheme$ = this.store.select(selectIsDualTheme);
  protected readonly language$ = this.store.select(selectLanguage);

  ngOnInit() {
    this.store.dispatch(GuideActions.init());
  }

  toggleGettingStartedGuide(): void {
    this.store.dispatch(GuideActions.toggleGuide());
  }

  dismissGuide() {
    this.store.dispatch(GuideActions.dismissGuide());
  }
}
